import { render, staticRenderFns } from "./reg-requirements-component.vue?vue&type=template&id=46563436&lang=html&"
import script from "./reg-requirements-component.vue?vue&type=script&lang=js&"
export * from "./reg-requirements-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports